export default __webpack_public_path__ + "static/media/Asset189.ef153bb5.svg";